import * as React from 'react';

import config from 'js/app/config';
import path from 'js/lib/path';

import { Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

const GRAD_ICON_SRC = path.join(config.url.assets, 'images/degree-home/grad_icon.svg');

export const EmptyCompletedCoursesMessage: React.FunctionComponent = () => {
  return (
    <div className="rc-EmptyCompletedCoursesMessage">
      <img className="grad-icon" src={GRAD_ICON_SRC} alt={_t('Grad Icon')} height="150" width="141" />
      <div className="headline-2-text align-horizontal-center">
        <Typography variant="h2">{_t('You do not have any active courses right now')}</Typography>
      </div>
      <div className="body-1-text align-horizontal-center p-b-3">
        <Typography2 component="p" variant="bodyPrimary">
          {_t('When your courses are in progress, they will appear here.')}
        </Typography2>
      </div>
    </div>
  );
};

export default EmptyCompletedCoursesMessage;
